// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MigrateSchematisationsBody
 */
export interface MigrateSchematisationsBody {
  /**
   *
   */
  dryRun: boolean;
  /**
   *
   */
  onlyProject?: string | null;
}

/**
 * Check if a given object implements the MigrateSchematisationsBody interface.
 */
export function instanceOfMigrateSchematisationsBody(
  value: object
): value is MigrateSchematisationsBody {
  if (
    (!("dryRun" in (value as Record<string, any>)) &&
      !("dry_run" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dryRun"] === undefined &&
      (value as Record<string, any>)["dry_run"] === undefined)
  )
    return false;
  return true;
}

export function MigrateSchematisationsBodyFromJSON(json: any): MigrateSchematisationsBody {
  return MigrateSchematisationsBodyFromJSONTyped(json, false);
}

export function MigrateSchematisationsBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MigrateSchematisationsBody {
  if (json == null) {
    return json;
  }
  return {
    dryRun: json["dry_run"],
    onlyProject:
      json["only_project"] === undefined
        ? undefined
        : json["only_project"] === null
        ? null
        : json["only_project"],
  };
}

export function MigrateSchematisationsBodyToJSON(json: any): MigrateSchematisationsBody {
  return MigrateSchematisationsBodyToJSONTyped(json, false);
}

export function MigrateSchematisationsBodyToJSONTyped(
  value?: MigrateSchematisationsBody | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    dry_run: value["dryRun"],
    only_project: value["onlyProject"],
  };
}
